import { SELECT_FACILITY, GET_MY_FACILITIES } from "./types";
import FacilityService from "../services/facility.service";

export const getFacility = (id) => (dispatch) => {
  return FacilityService.getFacility(id)
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch(() => {});
};

export const getFacilities = () => (dispatch) => {
  return FacilityService.getFacilities().then((response) => {
    const { data } = response;
    dispatch({
      type: GET_MY_FACILITIES,
      payload: { myfacilities: data },
    });
    return data;
  });
};

export const addFacility = (data) => (dispatch) => {
  return FacilityService.addFacility(data);
};

export const updateFacility = (facility_id, data) => (dispatch) => {
  return FacilityService.editFacility(facility_id, data);
};

export const selectFacility = (id) => (dispatch) => {
  localStorage.setItem("selectedFacility", JSON.stringify(id));
  console.log("selectFacility", id);
  dispatch({
    type: SELECT_FACILITY,
    payload: { selectedFacility: id },
  });
  return Promise.resolve();
};
